var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bb-col',{staticClass:"p-20",staticStyle:{"border":"8px dashed lightgrey"}},[_c('locale-changer'),_c('bb-radio',{attrs:{"label":"Route","grouped":"","options":_vm.routes,"name":"route-changer"},on:{"change":_vm.changeRoute}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }